import { render, staticRenderFns } from "./NgDataPolicy.vue?vue&type=template&id=7e73e87c"
import script from "./NgDataPolicy.vue?vue&type=script&lang=js"
export * from "./NgDataPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports